export default __webpack_public_path__ + "static/media/loup-garou-les-dechus.550de3f6.jpg";